module.exports = __webpack_public_path__ + "img/puzzle.f48029e.svg";